export default __webpack_public_path__ + "static/media/city-bg.7b307fa0.jpg";